import React from 'react';

const SKELETON_FIELD_KEYS = [
    'firstname',
    'lastname',
    'anumber',
    'mobile',
    'email',
    'companyname',
    'department',
    'occupation',
    'address',
    'country',
    'description',
    'keywords',
] as const;

const EditContactModalLoadingSkeleton = () => (
    <div
        aria-busy={true}
        className="pointer-events-none flex flex-col gap-y-6 opacity-50"
    >
        <div className="flex items-center gap-6">
            <div className="size-14 shrink-0 animate-pulse rounded-full bg-gray-200" />
            <div className="h-10 w-20 animate-pulse rounded bg-gray-200" />
        </div>
        <div className="flex flex-col gap-6">
            {SKELETON_FIELD_KEYS.map((key) => (
                <div key={key} className="flex flex-col gap-y-1.5">
                    <div className="h-5 w-24 animate-pulse rounded bg-gray-200" />
                    <div className="h-10 animate-pulse rounded bg-gray-200" />
                </div>
            ))}
        </div>
    </div>
);

export default EditContactModalLoadingSkeleton;
